import { CreditsSummary, CompanyContent } from 'src/services/ds.service'
import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { Option } from 'fp-ts/lib/Option'

export interface SelectCompany {
  type: 'SelectCompany'
  company: Option<CompanyContent>
}

export interface SelectTest {
  type: 'SelectTest'
  testId: Option<string>
}

export interface LoadCredits {
  type: 'LoadCredits'
  token: string
  companyId: string
  [startFetch]: string
}

export interface LoadCreditsSuccess {
  type: 'LoadCreditsSuccess'
  credits: CreditsSummary
  [stopFetch]: string
}

export interface LoadCreditsFailure {
  type: 'LoadCreditsFailure'
  [stopFetch]: string
}

export interface GiftCredits {
  type: 'GiftCredits'
  token: string
  credits: number
  testId: string
  companyId: string
  [startFetch]: string
}

export interface GiftCreditsSuccess {
  type: 'GiftCreditsSuccess'
  [stopFetch]: string
}

export interface GiftCreditsFailure {
  type: 'GiftCreditsFailure'
  [stopFetch]: string
}

export const giftCreditsActions = unionize({
  ...ofType<SelectTest>('SelectTest'),
  ...ofType<SelectCompany>('SelectCompany'),
  ...ofType<GiftCredits>('GiftCredits'),
  ...ofType<GiftCreditsSuccess>('GiftCreditsSuccess'),
  ...ofType<GiftCreditsFailure>('GiftCreditsFailure'),
  ...ofType<LoadCredits>('LoadCredits'),
  ...ofType<LoadCreditsSuccess>('LoadCreditsSuccess'),
  ...ofType<LoadCreditsFailure>('LoadCreditsFailure')
})

export type GiftCreditsActions = UnionOf<typeof giftCreditsActions>



// WEBPACK FOOTER //
// ./src/credits-components/gift-credits/gift-credits.actions.ts